/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { killswitchesBatchUserBadges } from "../funcs/killswitchesBatchUserBadges.js";
import { killswitchesCreate } from "../funcs/killswitchesCreate.js";
import { killswitchesEdit } from "../funcs/killswitchesEdit.js";
import { killswitchesGet } from "../funcs/killswitchesGet.js";
import { killswitchesLift } from "../funcs/killswitchesLift.js";
import { killswitchesList } from "../funcs/killswitchesList.js";
import { killswitchesListCapabilities } from "../funcs/killswitchesListCapabilities.js";
import { killswitchesListMCPServers } from "../funcs/killswitchesListMCPServers.js";
import { killswitchesPreviewOverlaps } from "../funcs/killswitchesPreviewOverlaps.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { KillswitchBatchUserBadgesResult } from "../models/components/killswitchbatchuserbadgesresult.js";
import { KillswitchDetail } from "../models/components/killswitchdetail.js";
import { KillswitchLiftResult } from "../models/components/killswitchliftresult.js";
import { KillswitchListCapabilitiesResult } from "../models/components/killswitchlistcapabilitiesresult.js";
import { KillswitchListMCPServersResult } from "../models/components/killswitchlistmcpserversresult.js";
import { KillswitchMutationReceipt } from "../models/components/killswitchmutationreceipt.js";
import { KillswitchPreviewOverlapsResult } from "../models/components/killswitchpreviewoverlapsresult.js";
import {
  KillswitchesBatchUserBadgesRequest,
  KillswitchesBatchUserBadgesSecurity,
} from "../models/operations/killswitchesbatchuserbadges.js";
import {
  KillswitchesCreateRequest,
  KillswitchesCreateSecurity,
} from "../models/operations/killswitchescreate.js";
import {
  KillswitchesEditRequest,
  KillswitchesEditSecurity,
} from "../models/operations/killswitchesedit.js";
import {
  KillswitchesGetRequest,
  KillswitchesGetSecurity,
} from "../models/operations/killswitchesget.js";
import {
  KillswitchesLiftRequest,
  KillswitchesLiftSecurity,
} from "../models/operations/killswitcheslift.js";
import {
  KillswitchesListRequest,
  KillswitchesListResponse,
  KillswitchesListSecurity,
} from "../models/operations/killswitcheslist.js";
import {
  KillswitchesListCapabilitiesRequest,
  KillswitchesListCapabilitiesSecurity,
} from "../models/operations/killswitcheslistcapabilities.js";
import {
  KillswitchesListMCPServersRequest,
  KillswitchesListMCPServersSecurity,
} from "../models/operations/killswitcheslistmcpservers.js";
import {
  KillswitchesPreviewOverlapsRequest,
  KillswitchesPreviewOverlapsSecurity,
} from "../models/operations/killswitchespreviewoverlaps.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class Killswitches extends ClientSDK {
  /**
   * batchUserBadges killswitches
   */
  async batchUserBadges(
    security: KillswitchesBatchUserBadgesSecurity,
    request: KillswitchesBatchUserBadgesRequest,
    options?: RequestOptions,
  ): Promise<KillswitchBatchUserBadgesResult> {
    return unwrapAsync(killswitchesBatchUserBadges(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * create killswitches
   */
  async create(
    security: KillswitchesCreateSecurity,
    request: KillswitchesCreateRequest,
    options?: RequestOptions,
  ): Promise<KillswitchMutationReceipt> {
    return unwrapAsync(killswitchesCreate(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * edit killswitches
   */
  async edit(
    security: KillswitchesEditSecurity,
    request: KillswitchesEditRequest,
    options?: RequestOptions,
  ): Promise<KillswitchMutationReceipt> {
    return unwrapAsync(killswitchesEdit(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * get killswitches
   */
  async get(
    security: KillswitchesGetSecurity,
    request: KillswitchesGetRequest,
    options?: RequestOptions,
  ): Promise<KillswitchDetail> {
    return unwrapAsync(killswitchesGet(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * lift killswitches
   */
  async lift(
    security: KillswitchesLiftSecurity,
    request: KillswitchesLiftRequest,
    options?: RequestOptions,
  ): Promise<KillswitchLiftResult> {
    return unwrapAsync(killswitchesLift(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * list killswitches
   */
  async list(
    security: KillswitchesListSecurity,
    request?: KillswitchesListRequest | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<KillswitchesListResponse, { cursor: string }>> {
    return unwrapResultIterator(killswitchesList(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * listCapabilities killswitches
   */
  async listCapabilities(
    security: KillswitchesListCapabilitiesSecurity,
    request?: KillswitchesListCapabilitiesRequest | undefined,
    options?: RequestOptions,
  ): Promise<KillswitchListCapabilitiesResult> {
    return unwrapAsync(killswitchesListCapabilities(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * listMCPServers killswitches
   */
  async listMCPServers(
    security: KillswitchesListMCPServersSecurity,
    request?: KillswitchesListMCPServersRequest | undefined,
    options?: RequestOptions,
  ): Promise<KillswitchListMCPServersResult> {
    return unwrapAsync(killswitchesListMCPServers(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * previewOverlaps killswitches
   */
  async previewOverlaps(
    security: KillswitchesPreviewOverlapsSecurity,
    request: KillswitchesPreviewOverlapsRequest,
    options?: RequestOptions,
  ): Promise<KillswitchPreviewOverlapsResult> {
    return unwrapAsync(killswitchesPreviewOverlaps(
      this,
      security,
      request,
      options,
    ));
  }
}
